import React from "react";
import CustomTimePicker from "@components/CustomTimePicker";
import TimeWheelComponent from "@components/TimedWheelComponent";

export default function TimedWheel() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100vw",
        height: "100vh",
        backgroundColor: "#F8F8FF",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <TimeWheelComponent></TimeWheelComponent>
      {/* <CustomTimePicker></CustomTimePicker> */}
    </div>
  );
}
